// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-default .card-body p.message.successMsg,
p.message.successMsg {
    color: #33AC2E;
    font-size: 12px;
    margin-top: 0px;

}

.card-default .card-body p.message.errorMsg,
p.message.errorMsg {
    color: #E84A50;
    font-size: 12px;
    margin-top: 0px;
}

.card-default .card-body p.message.normal,
p.message.normal {
    color: #005460;
    font-size: 12px;
    margin-top: 0px;
    border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Message/Message.css"],"names":[],"mappings":"AAAA;;IAEI,cAAc;IACd,eAAe;IACf,eAAe;;AAEnB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,eAAe;IACf,uBAAuB;AAC3B","sourcesContent":[".card-default .card-body p.message.successMsg,\np.message.successMsg {\n    color: #33AC2E;\n    font-size: 12px;\n    margin-top: 0px;\n\n}\n\n.card-default .card-body p.message.errorMsg,\np.message.errorMsg {\n    color: #E84A50;\n    font-size: 12px;\n    margin-top: 0px;\n}\n\n.card-default .card-body p.message.normal,\np.message.normal {\n    color: #005460;\n    font-size: 12px;\n    margin-top: 0px;\n    border: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
